























import { CreateElement, VNode } from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwSpinningProgress } from '../sw-progress';
import { utilService } from '../util-service';
import { domService } from '../dom-service';
import { DimensionRect, CSSStyleOptions, VueRenderFunction } from '../common-types';

const cssPrefix = 'sw-blocking-progress';

@Component({
  components: {
    SwSpinningProgress,
  },
})
export default class SwBlockingProgress extends SwExtendedVue {
  @Prop({ type: [String, Function] })
  message: string | VueRenderFunction;

  @Prop({ type: Number, default: 64 })
  size: number;

  @Prop({ type: Boolean, default: false })
  visible: boolean;

  @Prop({ type: Boolean, default: false })
  forViewport: boolean;

  @Prop({ type: Object, default: null })
  overlayDimension: DimensionRect | null;

  cssPrefix = cssPrefix;

  color: string = utilService.colorConst.selected;

  bodyStyleTicket: string = '';

  get rootStyle() {
    const style: CSSStyleOptions = {};
    if (this.overlayDimension) {
      style.top = `${this.overlayDimension.top}px`;
      style.left = `${this.overlayDimension.left}px`;
      style.width = `${this.overlayDimension.width}px`;
      style.height = `${this.overlayDimension.height}px`;
    }
    return style;
  }

  @Watch('visible', { immediate: true })
  private onVisibleChange() {
    if (this.visible) {
      if (this.forViewport) {
        this.bodyStyleTicket = domService.stylesManager.apply(document.body, { overflowX: 'hidden', overflowY: 'hidden' });
      }
    } else {
      if (!!this.bodyStyleTicket) {
        domService.stylesManager.cancel(document.body, this.bodyStyleTicket);
        this.bodyStyleTicket = '';
      }
    }
  }

  private beforeDestroy() {
    if (!!this.bodyStyleTicket) {
      domService.stylesManager.cancel(document.body, this.bodyStyleTicket);
      this.bodyStyleTicket = '';
    }
  }

  private render(h: CreateElement): VNode | null {// tslint:disable-line
    if (!this.visible) { return null; }

    const messageNode: VNode | null = (() => {
      if (!this.message) { return null; }
      return (
        <span class={[`${cssPrefix}__message`, 'sw-typo-heading-3', 'sw-flexbox', 'sw-flexbox--column', 'sw-flexbox--center-items']}
        >{typeof this.message === 'string' ? this.message : this.message(h)}</span>
      ) as VNode;
    })();

    const root: VNode = (
      <div
        class={[`${cssPrefix}`, { [`${cssPrefix}--for-body`]: this.forViewport },
          'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--center-justify',
        ]}
        style={this.rootStyle}
      >
        <div class={[`${cssPrefix}__cont`, 'sw-flexbox', 'sw-flexbox--column', 'sw-flexbox--center-items']}>
          <sw-spinning-progress size={`${this.size}px`} color={this.color} />
          { messageNode }
        </div>
      </div>
    ) as VNode;
    return root;
  }
}
